import { useState } from 'react';
// eslint-disable-next-line
import classNames from 'classnames';

import ButtonsCancelAndModify from '../TableView/tableContainer/ButtonsCancelAndModify/ButtonsCancelAndModify';

import styles from './SymbolDetailsButtons.module.scss';

type Props = {
    data: any;
    activeRowStyle: string;
}

const SymboDeatailsButtons = ({ activeRowStyle, data }: Props) => {
  const [swipedRow, setSwipedRow] = useState<number | undefined>(undefined);

  let touchStartX = 0;
  let touchEndX = 0;

  const handleTouchStart = (e) => {
    touchStartX = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX = e.touches[0].clientX;
  };

  const handleTouchEnd = (index: number) => {
    const swipeDistance = touchStartX - touchEndX;
    if (swipeDistance > 50) {
      setSwipedRow(index);
    } else if (swipeDistance < -50) {
      setSwipedRow(undefined);
    }
  };

  return (
    <div className={styles.wrapperPendingOrdersTable}>
      {data.map((row, index: number) => (
        <div
          key={row.id}
          className={classNames(styles.wrapperRow, { [styles.swipedLeft]: swipedRow === index })}
        >
          <div
            className={classNames(styles.row, {
              [styles.rowSwipped]: swipedRow === index,
            })}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={() => handleTouchEnd(index)}
          >
            <div className={styles.order}>
              <div className={styles.orderValueAndDate}>
                <div className={styles.quantityTypeAndPrice}>
                  <div className={styles.quantityAndPrice}>
                    {row.totalQuantity}
                    x
                    {row.setPrice}
                  </div>
                  <div className={styles.orderDetails}>
                    <div className={styles.orderType}>
                      {row.type}
                    </div>
                    <div className={styles.orderStatus}>
                      {row.quantity}
                    </div>
                  </div>
                </div>
                <div className={styles.expiryDate}>
                  {row.expiryDate}
                </div>
              </div>
            </div>
            <ButtonsCancelAndModify row={row} isSwipeable />
          </div>
        </div>
      ))}
    </div>
  );
};
export default SymboDeatailsButtons;
